import React from "react"
import styled, { css } from "styled-components"
import { media } from "../styles/media"
import { StaticImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import TransitionLink from "gatsby-plugin-transition-link"

//icons
import { BiRotateLeft } from "react-icons/bi"
import { IconContext } from "react-icons"

import Logo30 from "images/assets/logo30.svg"
import LogoKnow from "images/assets/logoKnow.svg"
import LogoLabo from "images/assets/logoLabo.svg"

const Reload = () => (
  <IconContext.Provider value={{ color: "white", size: "30px" }}>
    <BiRotateLeft />
  </IconContext.Provider>
)

const StyledWrap = styled.div`
  display: none;
  ${() =>
    media.tablet(css`
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;
      padding: 16px 5%;
      height: 150px;
      .top {
        width: 180px;
      }
    `)}
`

const StyledRight = styled.div`
  width: 60%;
  ${() =>
    media.pc(css`
      width: 50%;
    `)}
  display:flex;
  flex-flow: row nowrap;
  align-items: center;
  // justify-content: space-between;
  justify-content: flex-end;
  .navi {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    height: 150px;
    margin-right: 10px;
  }
`
//      a {
//        width: 80px;
//        ${() =>
//          media.pc(css`
//            width: 120px;
//            margin: 0 24px;
//          `)}
//        height: 60px;
//        margin: 0 16px;
//        padding: 10px;
//        display: flex;
//        flex-flow: row nowrap;
//        align-items: center;
//        justify-content: center;
//      }
//    }
// `

const StyledCircle = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  height: 150px;
  width: 45px;
  a {
    background: black;
    width: 45px;
    height: 45px;
    top: 50px;
    border-radius: 45px;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    position: absolute;
    svg {
      transition: 0.4s;
    }
    &:hover {
      svg {
        transform: rotate(-360deg);
      }
    }
  }
  .bar {
    height: 30px;
    width: 3px;
    background: black;
    position: absolute;
    top: 90px;
    border-radius: 3px;
  }
  .toTop {
    writing-mode: vertical-lr;
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 125px;
    height: 100px;
  }
`

const StyledLinkWrapper = styled.div`
  // width: 80px;
  width: 100px;
  ${() =>
    media.pc(css`
      width: 120px;
      margin: 0 24px;
    `)}
  height: 60px;
  margin: 0 16px;
  padding: 10px;
  background: "red";
`
const StyledUnderLine = styled.span`
  content: "";
  display: block;
  margin-top: 2px;
  border: 3px solid #dadada;
  border-radius: 36px;
`

const TabletHeader = props => {
  const { location } = props

  return (
    <StyledWrap>
      <Link to="/" className="top">
        <StaticImage
          src="../images/mainLogo.svg"
          alt="くらしと食物繊維"
          placeholder="none"
        />
      </Link>

      <StyledRight>
        <div className="navi">
          <StyledLinkWrapper>
            <TransitionLink to="/labo/">
              <LogoLabo />
              {/* <StaticImage
                src="../images/logoLabo.svg"
                alt="食物繊維Labo"
                placeholder="none"
                // onClick={navigate("/labo/")}
              /> */}
            </TransitionLink>
            {location?.pathname === "/labo/" && (
              <StyledUnderLine></StyledUnderLine>
            )}
          </StyledLinkWrapper>
          <StyledLinkWrapper>
            <TransitionLink to="/thirty-years/">
              <Logo30 />
              {/* <StaticImage
                src="../images/logo30.svg"
                alt="食物繊維30年"
                placeholder="none"
              /> */}
            </TransitionLink>
            {location?.pathname === "/thirty-years/" && (
              <StyledUnderLine></StyledUnderLine>
            )}
          </StyledLinkWrapper>
          <StyledLinkWrapper>
            <TransitionLink to="/bits-of-knowledge/">
              <LogoKnow />
              {/* <StaticImage
                src="../images/logoKnow.svg"
                alt="食物繊維の豆知識"
                placeholder="none"
              /> */}
            </TransitionLink>
            {location?.pathname === "/bits-of-knowledge/" && (
              <StyledUnderLine></StyledUnderLine>
            )}
          </StyledLinkWrapper>
        </div>
        <StyledCircle>
          <TransitionLink to="/">
            <Reload />
          </TransitionLink>
          <span className="bar"></span>
          <span className="toTop">TOP PAGE</span>
        </StyledCircle>
      </StyledRight>
    </StyledWrap>
  )
}

export default TabletHeader
